<template>
  <div>
    <b-modal
      id="add"
      no-close-on-backdrop
      hide-footer
      title="ADICIONAR SINAIS VITAIS (SSVV)"
    >
      <WarningMessage
        v-if="!createdAt"
        message="NÃO PODE REALIZAR QUAISQUER ALTERAÇÕES APÓS A DATA DE CADASTRO"
      />
      <div class="row" v-if="createdAt">
        <div class="col-md-12">
          <h6 class="worksansr">TIPO DE MEDIÇÃO VITAL</h6>
          <select
            @change="handleChangeVitalSigns($event.target.value)"
            v-model="type"
            class="form-control"
          >
            <option value="">SELECIONE...</option>
            <option :key="item.id" :value="item.name" v-for="item in types">
              {{ item.name }}
              {{ item.abbreviation ? ` - ${item.abbreviation}` : "" }}
            </option>
          </select>
        </div>
        <div
          v-show="type == 'DOR'"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
        >
          <h6 class="mb-1 color-blue text-for">DOR - ESCALA EVA:</h6>
          <div class="row">
            <div
              class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 border-right text-center"
            >
              <img width="25" src="../../../../assets/emoji/1.png" />
              <h6 class="mb-0 text-for">SEM DOR</h6>
              <span class="worksansr">0</span>
            </div>
            <div
              class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 border-right text-center"
            >
              <img width="25" src="../../../../assets/emoji/1.png" />
              <h6 class="mb-0 text-for">LEVE</h6>
              <span class="worksansr">1-3</span>
            </div>
            <div
              class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 border-right text-center"
            >
              <img width="25" src="../../../../assets/emoji/3.png" />
              <h6 class="mb-0 text-for">MODERADA</h6>
              <span class="worksansr">4-7</span>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 text-center">
              <img width="25" src="../../../../assets/emoji/4.png" />
              <h6 class="mb-0 text-for">INTENSA</h6>
              <span class="worksansr">8-10</span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="input-group">
            <input
              v-if="show_description"
              type="text"
              class="form-control"
              v-model="description"
              placeholder="VALOR"
            />

            <select
              v-if="show_diuresis"
              v-model="description"
              class="form-control"
            >
              <option value="">SELECIONE...</option>
              <option
                :key="key"
                :value="item"
                v-for="(item, key) in types_diuresis"
              >
                {{ item }}
              </option>
            </select>

            <select
              v-if="show_evacuation"
              v-model="description"
              class="form-control"
            >
              <option value="">SELECIONE...</option>
              <option
                :key="key"
                :value="item"
                v-for="(item, key) in types_evacuation"
              >
                {{ item }}
              </option>
            </select>
            <h6
              v-if="show_blood_pressure"
              class="d-flex align-items-center pl-2 pr-2 pt-1 worksansr"
            >
              POR
            </h6>

            <input
              v-if="show_blood_pressure"
              type="text"
              class="form-control"
              placeholder="VALOR"
              v-model="final_description"
            />
            <div v-if="show_icon" class="input-group-pprend">
              <v-btn disabled><i :class="icon" /></v-btn>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <label>OBSERVAÇÃO</label>
          <ChromeSpeechToTextTextarea rows="4" max-rows="10" v-model="note" />
        </div>
        <div v-if="errors.length > 0" class="col-md-12">
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-md-12 text-right">
          <v-btn class="btn-add" @click="handleAddVitalSigns">
            <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
          </v-btn>
        </div>
        <div class="col-md-12">
          <v-data-table
            dense
            :headers="[
              { text: 'TIPO', value: 'type' },
              { text: 'DESCRIÇÃO', value: 'description' },
              { text: 'OBSERVAÇÃO', value: 'note' },
              { text: '', value: 'action' },
            ]"
            :items="vital_signs"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
          >
            <template v-slot:[`item.description`]="{ item }">
              {{ item.title }} {{ item.description }}
              {{
                item.type == "DOR"
                  ? `(${handleDescriptionAche(item.description)})`
                  : item.abbreviation
              }}
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <confirmation-dialog
                small
                message-title="EXCLUIR?"
                message-body="Deseja realmente remover?"
                open-class="btn-delete"
                open-left-icon="fa-trash"
                open-text="EXCLUIR"
                @yes="deleteVitalSigns(item.id)"
              />
            </template>
          </v-data-table>
        </div>
        <div class="col-md-12 text-right">
          <confirmation-dialog
            :disabled="loadingCreate"
            message-title="FINALIZAR?"
            message-body="Deseja realmente finalizar?"
            open-class="btn-notcertified"
            open-left-icon="fa-check"
            open-text="FINALIZAR MANUAL COM ASSINATURA ELETRÔNICA"
            @yes="create"
          />
        </div>
      </div>
    </b-modal>
    <div class="row">
      <div
        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 d-flex align-items-center"
      >
        <h6 class="subtitles mb-0 worksansr check-text-center">
          NOME: <strong>{{ resident_name }}</strong>
        </h6>
      </div>
      <div
        v-if="$store.state.online"
        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 text-right"
      >
        <!-- <v-btn @click="handleModalAddVitalSigns" class="btn-add mt-1 mr-1">
          <i class="fas fa-plus mr-2 text-twenty"></i>
          ADICIONAR
        </v-btn> -->
        <ButtonGenerateCertificate
          v-if="care_vital_signs && care_vital_signs.data_base64"
          :id="care_vital_signs.id"
          :data_base64="
            care_vital_signs && care_vital_signs.data_base64
              ? care_vital_signs.data_base64
              : ''
          "
        />
        <v-btn v-on:click="print" class="btn-print mt-1">
          <i class="fas fa-print mr-2 text-twenty"></i>
          IMPRIMIR
        </v-btn>
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <b-overlay :show="loading" opacity="0.99">
          <v-data-table
            dense
            :headers="[
              { text: 'TIPO', value: 'type' },
              { text: 'DESCRIÇÃO', value: 'description' },
              { text: 'OBSERVAÇÃO', value: 'note' },
              { text: 'USUÁRIO', value: 'user_name' },
              { text: 'DATA CADASTRO', value: 'created_at' },
              { text: 'STATUS', value: 'status' },
            ]"
            :items="care_has_vital_signs"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
          >
            <template v-slot:[`item.type`]="{ item }">
              <strong>{{ item.type }} </strong>
            </template>
            <template v-slot:[`item.description`]="{ item }">
              <strong
                >{{ item.type != "DOR" ? item.description : "" }}
                {{
                  item.type == "DOR"
                    ? `(${handleDescriptionAche(item.description)})`
                    : item.abbreviation
                }}</strong
              >
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <span
                :class="[
                  'font-weight-bold',
                  'text-success',
                  item.status == 1 ? 'text-warning' : 'FINALIZADO',
                ]"
              >
                {{ item.status == 1 ? "EM ABERTO" : "FINALIZADO" }}
              </span>
            </template>
            <template v-slot:[`item.created_at`]="{ item }">{{
              formatDate(item.created_at)
            }}</template>
          </v-data-table>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import WarningMessage from "../../../Components/WarningMessage";

import ChromeSpeechToTextTextarea from "../../../Components/ChromeSpeechToTextTextarea";

import ConfirmationDialog from "../../../Components/ConfirmationDialog";

import ButtonGenerateCertificate from "../../../Components/ButtonGenerateCertificate";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import { formatDate, generateId, isNumeric } from "../../../../lib/format";

import { getStatic } from "../../../../lib/functions";

import routes from "../../../../routes";

export default {
  name: "VitalSigns",
  components: {
    ErrorsMessages,
    WarningMessage,
    ChromeSpeechToTextTextarea,
    ConfirmationDialog,
    ButtonGenerateCertificate,
  },
  props: {
    id: [String, Number],
    rest_home_id: [String, Number],
    resident_id: [String, Number],
    resident_name: [String, Number],
    user: Object,
    createdAt: [Boolean],
  },
  data() {
    return {
      accessed_offline: false,
      types: [
        {
          id: 7,
          name: "DIURESE",
          abbreviation: "",
        },
        { id: 5, name: "DOR", abbreviation: "" },
        {
          id: 8,
          name: "EVACUAÇÃO",
          abbreviation: "",
        },
        {
          id: 4,
          name: "FREQUÊNCIA RESPIRATÓRIA",
          abbreviation: "(R) irpm",
        },
        {
          id: 6,
          name: "GLICEMIA CAPILAR",
          abbreviation: "(DX) mg/dl",
        },
        {
          id: 2,
          name: "PULSO (FREQUÊNCIA CARDÍACA)",
          abbreviation: "(P) - BPM",
        },
        { id: 3, name: "PRESSÃO ARTERIAL", abbreviation: "(P.A) mmHg" },
        {
          id: 9,
          name: "SATURAÇÃO DE OXIGÊNIO",
          abbreviation: "%",
        },
        { id: 1, name: "TEMPERATURA CORPORAL", abbreviation: "(T) ºC" },
        // { id: 10, name: "PESO", abbreviation: "KG" },
        // { id: 11, name: "ALTURA", abbreviation: "ALTURA" },
      ],
      types_diuresis: [
        "AUSÊNCIA DE DIURESE",
        "DIURESE PRESENTE",
        "POUCA DIURESE",
      ],
      types_evacuation: [
        "AUSENTE",
        "BEM MOLDADAS",
        "EM CÍBALOS",
        "LÍQUIDA",
        "PASTOSA",
      ],
      vital_signs: [],
      product_kit_id: "",
      vital_sign: {},
      type: "",
      description: "",
      final_description: "",
      title: "",
      abbreviation: "",
      note: "",
      care_vital_signs: null,
      care_has_vital_signs: [],
      kits: [],
      loading: true,
      loadingCreate: false,
      show_description: true,
      show_capillary_glycemia: false,
      show_blood_pressure: false,
      show_icon: false,
      show_diuresis: false,
      show_evacuation: false,
      icon: "",
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    generateId,
    isNumeric,
    handleModalAddVitalSigns() {
      this.vital_signs = [];
      this.$bvModal.show("add");
    },
    handleDescriptionAche(nivel) {
      if (parseInt(nivel) == 0 || !nivel) {
        return "SEM DOR";
      } else if (parseInt(nivel) >= 1 && parseInt(nivel) <= 3) {
        return "DOR LEVE";
      } else if (parseInt(nivel) >= 4 && parseInt(nivel) <= 7) {
        return "DOR MODERADA";
      } else if (parseInt(nivel) >= 8 && parseInt(nivel) <= 10) {
        return "DOR INTENSA";
      }
    },
    handleChangeVitalSigns(value) {
      this.show_blood_pressure = false;
      this.show_capillary_glycemia = false;
      this.show_diuresis = false;
      this.show_evacuation = false;
      this.show_description = false;

      switch (String(value)) {
        case "TEMPERATURA CORPORAL":
          this.title = "(T)";
          this.abbreviation = "ºC";
          this.show_description = true;
          break;
        case "PULSO (FREQUÊNCIA CARDÍACA)":
          this.title = "(P)";
          this.abbreviation = "BPM";
          this.show_description = true;
          break;
        case "PRESSÃO ARTERIAL":
          this.title = "(P.A)";
          this.abbreviation = "mmHg";
          this.show_description = true;
          this.show_blood_pressure = true;
          break;
        case "FREQUÊNCIA RESPIRATÓRIA":
          this.title = "(R)";
          this.abbreviation = "irpm";
          this.show_description = true;
          break;
        case "DOR":
          this.title = "DOR";
          this.abbreviation = "";
          this.show_description = true;
          break;
        case "GLICEMIA CAPILAR":
          this.title = "(DX)";
          this.abbreviation = "mg/dl";
          this.show_description = true;
          this.show_capillary_glycemia = true;
          break;
        case "DIURESE":
          this.title = "";
          this.abbreviation = "";
          this.show_diuresis = true;
          break;
        case "EVACUAÇÃO":
          this.title = "";
          this.abbreviation = "";
          this.show_evacuation = true;
          break;
        case "SATURAÇÃO DE OXIGÊNIO":
          this.title = "";
          this.abbreviation = "%";
          this.show_description = true;
          break;
        case "PESO":
          this.title = "";
          this.abbreviation = "KG";
          this.show_description = true;
          break;
        case "ALTURA":
          this.title = "";
          this.abbreviation = "";
          this.show_description = true;
          break;
      }
    },
    async retrieve() {
      let accessed_offline = JSON.parse(
        sessionStorage.getItem("accessed_offline") || !this.$store.state.online
      );

      this.accessed_offline = accessed_offline;

      if (accessed_offline) {
        try {
          let residents = (
            await getStatic("/offline/residents/vital-signs", true)
          ).residents;

          let vitalSigns = [];
          for (let resident of residents) {
            vitalSigns.push(...resident.vitalSigns);
          }

          let care_has_vital_signs = vitalSigns.filter(
            (item) => item.id == this.id
          );

          if (care_has_vital_signs[0]) {
            this.care_has_vital_signs =
              care_has_vital_signs[0].care_has_vital_signs;
          }
        } catch (errors) {
          this.errors = errors;
        }

        this.loading = false;
      } else {
        await this.get();
        await this.getKits();
      }
    },
    async get() {
      try {
        this.loading = true;

        const { id } = this;

        var params = { id };

        const response = await api.get("/rest-home/care/vital-signs/get", {
          params,
        });

        const { error, care_vital_signs, care_has_vital_signs } = response.data;

        if (error) {
          return routes.go(-1);
        }

        this.care_vital_signs = care_vital_signs;
        this.care_has_vital_signs = care_has_vital_signs;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getKits() {
      try {
        const { rest_home_id } = this;

        var params = { rest_home_id };

        const response = await api.get(
          "/rest-home/product/kit/get/with/products/added",
          {
            params,
          }
        );

        const { error, kits } = response.data;

        if (!error) {
          this.kits = kits;
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleAddVitalSigns() {
      let {
        description,
        final_description,
        type,
        title,
        abbreviation,
        note,
        product_kit_id,
      } = this;

      if (!type) {
        this.errors = [{ id: 1, message: "Informe o tipo de medição" }];
        return;
      }

      var types = [
        "TEMPERATURA CORPORAL",
        "PULSO (FREQUÊNCIA CARDÍACA)",
        "PRESSÃO ARTERIAL",
        "FREQUÊNCIA RESPIRATÓRIA",
        "DOR",
        "GLICEMIA CAPILAR",
        "DIURESE",
        "EVACUAÇÃO",
        "SATURAÇÃO DE OXIGÊNIO",
        "PESO",
        "ALTURA",
      ];

      if (!types.includes(type)) {
        this.errors = [{ id: 1, message: "Informe tipo de medição" }];
        return;
      }

      if (!description) {
        this.errors = [{ id: 1, message: "Informe todos os campos" }];
        return;
      }

      if (type == "PRESSÃO ARTERIAL") {
        if (!final_description) {
          this.errors = [{ id: 1, message: "Informe todos os campos" }];
          return;
        }
      }

      if (type == "DOR") {
        if (!isNumeric(description)) {
          this.errors = [{ id: 1, message: "Informe apenas números" }];
          return;
        }

        if (parseInt(description) > 10) {
          this.errors = [{ id: 1, message: "Informe número entre [0, 10]" }];
          return;
        }
      }

      if (type == "TEMPERATURA CORPORAL") {
        let validate_description = String(description)
          .replace(",", "")
          .replace(".", "");

        if (!isNumeric(validate_description)) {
          this.errors = [{ id: 1, message: "Informe apenas números" }];
          return;
        }

        description = String(description).replace(",", ".");
      }

      if (type == "PESO") {
        let validate_description = String(description)
          .replace(",", "")
          .replace(".", "");

        if (!isNumeric(validate_description)) {
          this.errors = [{ id: 1, message: "Informe apenas números" }];
          return;
        }

        description = String(description).replace(",", ".");
      }

      if (type == "ALTURA") {
        let validate_description = String(description)
          .replace(",", "")
          .replace(".", "");

        if (!isNumeric(validate_description)) {
          this.errors = [{ id: 1, message: "Informe apenas números" }];
          return;
        }

        description = String(description).replace(",", ".");
      }

      if (
        type != "DIURESE" &&
        type != "EVACUAÇÃO" &&
        type != "TEMPERATURA CORPORAL" &&
        type != "PESO" &&
        type != "ALTURA"
      ) {
        if (!isNumeric(description)) {
          this.errors = [{ id: 1, message: "Informe apenas números" }];
          return;
        }
        if (type == "PRESSÃO ARTERIAL") {
          if (!isNumeric(final_description)) {
            this.errors = [{ id: 1, message: "Informe apenas números" }];
            return;
          }
          if (parseInt(description) < 29) {
            this.errors = [{ id: 1, message: "Informe valor acima de 29x39" }];
            return;
          }
          if (parseInt(final_description) < 39) {
            this.errors = [{ id: 1, message: "Informe valor acima de 29x39" }];
            return;
          }
        }
      }

      let initial_description = "";
      if (type == "PRESSÃO ARTERIAL") {
        initial_description = description;
        description = `${description}X${final_description}`;
      }

      var obj = {
        id: generateId(),
        type,
        description,
        initial_description,
        final_description,
        title,
        abbreviation,
        note,
        product_kit_id,
      };

      this.vital_signs.push(obj);

      this.type = "";
      this.description = "";
      this.note = "";
      this.final_description = "";
      this.show_capillary_glycemia = false;
      this.product_kit_id = "";
      this.errors = [];
    },
    async create() {
      try {
        this.loadingCreate = true;

        const { id: care_vital_sign_id, user, vital_signs } = this;

        var params = {
          care_vital_sign_id,
          user_id: user.id,
          vital_signs,
        };

        const response = await api.post(
          "/rest-home/care/vital-signs/create",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("add");
          this.get();
          toast(message, "success");
          this.type = "";
          this.description = "";
          this.final_description = "";
          this.note = "";
          this.show_capillary_glycemia = false;
          this.product_kit_id = "";
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    deleteVitalSigns(id) {
      try {
        const { vital_signs } = this;

        vital_signs.map((item, key) => {
          if (item.id == id) {
            vital_signs.splice(key, 1);
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    async deleteVitalSignsAdded(id) {
      try {
        const { user } = this;

        let data = { id, user_id: user.id };

        const response = await api.delete(
          "/rest-home/care/vital-signs/delete",
          {
            data,
          }
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.get();
          toast(message, "success");
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
    print() {
      const { id } = this;

      let route = this.$router.resolve({
        name: "print_vital_sign",
        params: {
          id,
        },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>
